import { render, staticRenderFns } from "./SfSteps.vue?vue&type=template&id=1dffe1f2&scoped=true"
import script from "./SfSteps.vue?vue&type=script&lang=ts"
export * from "./SfSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dffe1f2",
  null
  
)

export default component.exports